/**
 * Idempotencia — Portal Cliente Menuee
 *
 * Responsabilidad: generar claves UUID reutilizables en reintentos de red.
 *
 * Consume: crypto.randomUUID() del runtime.
 *
 * Qué nunca debe hacer:
 * - Persistir claves en storage (cada intento de operación usa una clave nueva;
 *   los reintentos del MISMO intento reutilizan la misma clave en la capa RPC).
 * - Generar claves determinísticas derivadas del payload (rompe idempotencia).
 */

/**
 * Genera una clave de idempotencia (UUID v4) para RPC E2, E3, E6, etc.
 *
 * @returns {string}
 */
export function generateIdempotencyKey() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  // Fallback mínimo para entornos sin crypto.randomUUID (tests / legacy).
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
